import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import ThemeWrapperChat from '@/layouts/ThemeWrapperChat';
import RouteErrorFallback from '@/components/RouteErrorFallback';

const ChatPage = lazy(() => import('@/pages/ChatPage'));
const ChatRedirectedErrorPage = lazy(() => import('@/pages/ChatRedirectedErrorPage'));
const EmbedTestPage = lazy(() => import('@/pages/EmbedTestPage'));

// Full-page loading fallback shown while lazy chunks are being fetched.
// Keeps a white screen rather than a blank/broken render.
function PageLoadingFallback() {
  return <div className="fixed inset-0 bg-white" aria-busy="true" />;
}

// Create the router once at module level so that React Router's internal state
// is never discarded on a re-render (which would cause lazy chunks to fail
// mid-load on hard reload or after clearing localStorage).
//
// TELV1-489: the errorElement lives on a pathless WRAPPER route above
// ThemeWrapperChat — attached to the ThemeWrapperChat route itself, a render
// error thrown by the wrapper would bubble past its own boundary and land on
// React Router's default stack-trace page, unreported to Sentry.
const router = createBrowserRouter([
  {
    errorElement: <RouteErrorFallback />,
    children: [
      {
        element: <ThemeWrapperChat />,
        children: [
          {
            index: true,
            path: '/:chat_id',
            element: (
              <Suspense fallback={<PageLoadingFallback />}>
                <ChatPage />
              </Suspense>
            ),
          },
          {
            path: '/test/:chat_id',
            element: (
              <Suspense fallback={<PageLoadingFallback />}>
                <EmbedTestPage />
              </Suspense>
            ),
          },
          // catch errors
          {
            path: '*',
            element: (
              <Suspense fallback={<PageLoadingFallback />}>
                <ChatRedirectedErrorPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
]);

export default router;
